var e={togglerLabel:"Label__togglerLabel--bc",text:"Label__text-zJM",isBolded:"Label__isBolded-s12"};export{e as default};
